module.exports = __webpack_public_path__ + "img/hero_portrait_crusader_male.974bc5e4.png";